import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
//API
import { BankConsilationFetchAPI } from '../../../api/BankConsilation';
//Alerts
import ErrorAlert from '../../Alerts/ErrorAlert';
import SuccessAlert from '../../Alerts/SuccessAlert';
import LoadingAlert from '../../Alerts/LoadingAlert';

const ModalNewProposal = ({ setEventHandlerShowTemplateModal, setEventHandler, modalComponente, token, business_code }) => {

    const [showModal, setShowModal] = useState(false)
    const [bankStatementTemplates, setBankStatementTemplates] = useState([]);
    const [bankStatementName, setBankStatementName] = useState(null); // Estado para el nombre del estado bancario
    const [bankStatementTemplateId, setBankStatementTemplateId] = useState(null); // Estado para el id de la plantilla bancaria
    const [bankName, setBankName] = useState(null); // Estado para el nombre del banco
    const [selectedTemplate, setSelectedTemplate] = useState(null); // Estado para la plantilla seleccionada
    const [step, setStep] = useState(1); // Estado para el paso actual
    const totalSteps = 3; // Número total de pasos

    const nextStep = () => {
        if (step < totalSteps) setStep(step + 1);
    };

    const prevStep = () => {
        if (step > 1) setStep(step - 1);
    };

    useEffect(() => {
        if (!showModal) {
            setStep(1);
        }
    }, [showModal]);


    //Dropzone fILE
    const [fileName, setFileName] = useState('No hay ningún archivo seleccionado');
    const [file, setFile] = useState(null);

    const handleFileChange = (e) => {
        if (e.target.files.length > 0) {
            setFileName(e.target.files[0].name);
            setFile(e.target.files[0]);
        } else {
            setFileName('No hay ningún archivo seleccionado');
            setFile(null);
        }
    };


    //Function to get the bank statement templates
    const getBankStatementTemplates = async () => {
        try {
            const response = await BankConsilationFetchAPI.getBankStatementsTemplates(token, "all", business_code);
            //If the response is ok we set the bank statement templates
            setBankStatementTemplates(response.data.templates);
        } catch (err) {
            setBankStatementTemplates([]);
        }
    }

    // Function to save the bank statement 
    const handleSaveBankStatement = async () => {
        //We check if the file is null or the bank name is null
        if (!file || !bankName) {
            ErrorAlert("Error", "Debe seleccionar un banco y un archivo.", "error");
            return;
        } else {

            LoadingAlert("Procesando archivo", "Subiendo y analizando el archivo...");
            try {
                await BankConsilationFetchAPI.saveBankStatement(token, bankName, business_code, file, selectedTemplate, bankStatementName, bankStatementTemplateId);
                SuccessAlert("Archivo procesado", "Los movimientos han sido registrados correctamente", "success");
                //We close the modal
                setShowModal(false);
                //We make the event handler to refresh the bank statements
                setEventHandler(1)
            } catch (err) {
                ErrorAlert("Error al procesar el archivo", err.message, "error");
            }
        }
    };

    return (
        <>
            <div>
                <button className='btn btn-light bg-white btn-sm  fw-normal text-dark border border-1 rounded-2 text-nowrap '
                    onClick={() => { setShowModal(true); getBankStatementTemplates() }} >
                    Crear Propuesta
                </button>
            </div>

            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                size='large'
                centered>
                <Modal.Body>

                    <div className='position-relative '>

                        <div className='position-absolute top-0 start-100 translate-middle mt-2 '>
                            <div className='me-3'>
                                <button class="btn btn-outline-secondary border-0 bg-light text-secondary rounded-circle p-2 lh-1"
                                    type="button" title='Cerrar'
                                    onClick={() => setShowModal(false)}

                                >
                                    <i class="uil uil-multiply"></i>
                                </button>
                            </div>
                        </div>
                        <h2 className="title-main-login  text-center ">
                            Crear Propuesta
                        </h2>

                        <div>

                            {/* ******** Step 01 ******** */}
                            <div className={`paso ${step === 1 ? "activo" : ""}`}>

                                <Form.Group className="my-5">
                                    <Form.Label className='text-black fw-semibold'>¿Cómo desea nombrar esta propuesta de conciliación?</Form.Label>
                                    <Form.Control type="text" placeholder="Ingresar..." name="name"  value={bankStatementName} onChange={(e)=> setBankStatementName(e.target.value)}/>
                                </Form.Group>
                            </div>

                            {/* ******** Step 02 ******** */}
                            <div className={`paso ${step === 2 ? "activo" : ""}`}>
                                <Form.Group className="mt-5 mb-3">
                                    <Form.Label className='text-black fw-semibold'>Seleccione la plantilla bancaria que desea usar</Form.Label>
                                    <Form.Select
                                        aria-label="Default select example"
                                        name="bank_template"
                                        onChange={(e) => {
                                            e.target.value !== "" ? setSelectedTemplate(JSON.parse(e.target.value)) : setSelectedTemplate(null); 
                                            setBankName(e.target.options[e.target.selectedIndex].getAttribute("data-bank"));
                                            setBankStatementTemplateId(e.target.options[e.target.selectedIndex].getAttribute("data-id"));
                                        }}
                                    >
                                        <option value="">Seleccione...</option>
                                        {bankStatementTemplates.map((template, index) => (
                                            <option key={index} value={JSON.stringify(template.template)} data-id={template._id} data-bank={template.bank_name}>
                                                {template.bank_name + ": " + template.name}
                                            </option>
                                        ))}

                                    </Form.Select>

                                </Form.Group>

                                <p className='text-center'>
                                    <i class="uil uil-info-circle"></i> <br />  ¿Aún no ha creado una plantilla o no tienes una especifica para su banco?
                                    <span className='fw-semibold text-primary ms-1' role='button' onClick={() => (modalComponente(true))} >
                                        Crear nueva plantilla bancaria.

                                    </span>
                                </p>

                            </div>

                            {/* ******** Step 03 ******** */}
                            <div className={`paso ${step === 3 ? "activo" : ""}`}>
                                <h4> SubirExcel de estado bancario </h4>

                                <div className=" p-3 bg-white rounded-3 border mt-5">
                                    <h6 className="fw-semibold">Subir Archivo </h6>
                                    <div className="dropzone-container">
                                        <label htmlFor="dropzone-file" className="dropzone-label">
                                            <div className="dropzone-content">
                                                <svg
                                                    className="dropzone-icon"
                                                    aria-hidden="true"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 20 16"
                                                >
                                                    <path
                                                        stroke="currentColor"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth="2"
                                                        d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                                                    />
                                                </svg>
                                                <p className="dropzone-text">
                                                    <span className="dropzone-bold">Haga clic para cargar archivo de Estado de Cuenta Bancario </span>
                                                </p>

                                                <p className="file-name">{fileName}</p>
                                            </div>
                                            <input
                                                id="dropzone-file"
                                                type="file"
                                                accept=".xlsx, .xls"
                                                className="dropzone-input"
                                                onChange={(event) => {
                                                    handleFileChange(event);
                                                }}
                                            />
                                        </label>
                                    </div>
                                </div>

                                <div className="mt-3 d-flex justify-content-end">
                                    <button className="btn btn-save-sp" onClick={handleSaveBankStatement} type="button">
                                        Guardar
                                    </button>
                                </div>
                            </div>

                            <div className="botones-navegacion">
                                <button onClick={prevStep} disabled={step === 1} type="button">
                                    Anterior
                                </button>
                                <button onClick={nextStep} disabled={step === totalSteps} type="button" >
                                    Siguiente
                                </button>
                            </div>
                        </div>








                    </div>



                </Modal.Body>
            </Modal >

        </>
    )
}

export default ModalNewProposal